import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClick"];
import enviro from 'enviro';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { CopyTextArea } from 'foundations-components/transitional/components/CopyTextArea';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useState, useCallback } from 'react';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Alert } from 'foundations-components/transitional/components/Alert';
import getV4DeveloperCode from 'forms-utils-lib/embedCode/getV4DeveloperCode';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ShareCopyButton = _ref => {
  let {
      onClick
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Flex, {
    flexWrap: "wrap",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    children: /*#__PURE__*/_jsx(CopyButton, Object.assign({}, props, {
      onClick: onClick,
      marginBlockStart: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developerCode.copy"
      })
    }))
  });
};
export const DeveloperCode = ({
  formGuid,
  onClick
}) => {
  const [acceptsRisks, setAcceptsRisks] = useState(false);
  const onAcceptRisksChange = useCallback(({
    target: {
      checked
    }
  }) => {
    setAcceptsRisks(checked);
  }, []);
  const developerCode = getV4DeveloperCode(Object.assign({
    formId: formGuid,
    region: enviro.getHublet()
  }, enviro.isQa() && {
    env: 'qa'
  }));
  const buttonRowRenderer = props => {
    return /*#__PURE__*/_jsx(ShareCopyButton, Object.assign({}, props, {
      onClick: onClick
    }));
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Alert, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developerCode.warnings.developerCodeTitle"
      }),
      type: "warning",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developerCode.warnings.developerCodeDescription"
      })
    }), /*#__PURE__*/_jsx(Checkbox, {
      checked: acceptsRisks,
      onChange: onAcceptRisksChange,
      marginBlockStart: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developerCode.labels.understandRisks"
      })
    }), acceptsRisks && /*#__PURE__*/_jsx(CopyTextArea, {
      "data-test-id": "developer-code-text-area",
      marginBlockStart: "400",
      buttonRowRenderer: buttonRowRenderer,
      use: "code",
      value: developerCode
    })]
  });
};